import { styled } from '@mui/material';
import { Flex } from '../../../base/Flex';
import { colorPalettes } from '../../../../context/theme';
import { Text } from '../../../base/Text';
import {
  ICON_SIZES,
  LINE_HEIGHT,
  PADDING,
  SIZES,
} from '../../../../constants/sizes';

export const StyledOrgDetails = styled(Flex)``;

export const StyledOrgDetailsImage = styled('div')`
  padding-right: ${PADDING['x-medium']};
`;

export const StyledOrgDetailsImageIcon = styled('img')`
  width: ${ICON_SIZES['medium']};
  height: ${ICON_SIZES['medium']};
  border-radius: 50%;
`;

export const StyledOrgDetailsName = styled(Text)`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.avatar.text};
  font-size: ${SIZES['small']};
  font-weight: 400;
  line-height: ${LINE_HEIGHT['large']};
`;
